export const environment =
{
  mode: 'development',
  advContabilApi: 'https://app.advventure.com.br',
  IBGEApi: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/',
  IBGEApiMunicipios: 'https://servicodados.ibge.gov.br/api/v1/localidades/municipios/',
  FocusNFEHomolog: 'https://homologacao.focusnfe.com.br/',
  FocusNFEProd: 'https://api.focusnfe.com.br/v2/',
  production: false,
  staging: false,
  brasilApi: 'https://brasilapi.com.br/api/banks/v1'
}
